import { useState, useEffect, useCallback } from 'react';
import adminMonthlyReportService from '../service/adminService.mjs';



export const useAdminMonthlyReports = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Defaults kept in one place so "Clear filters" and the initial state can
  // never drift apart.
  const defaultFilters = () => ({
    year: new Date().getFullYear(),
    status: 'all'
  });

  const [filters, setFilters] = useState(defaultFilters);

  const fetchReports = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const fetchedReports = await adminMonthlyReportService.getAdminMonthlyReports(filters);
      setReports(fetchedReports);
    } catch (err) {
      setError('Failed to fetch reports: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const updateFilter = (key, value) => {
    setFilters(prev => ({ ...prev, [key]: value }));
  };

  const clearFilters = () => {
    setFilters(defaultFilters());
  };

  const refreshReports = () => {
    fetchReports();
  };

  // Drops the row on success rather than refetching, so the table does not
  // flash its loading state. Throws for the page to show the reason.
  const deleteDraftReport = async (reportId) => {
    await adminMonthlyReportService.deleteDraftReport(reportId);
    setReports(prev => prev.filter(r => r._id !== reportId));
  };

  return {
    reports,
    loading,
    error,
    filters,
    updateFilter,
    clearFilters,
    refreshReports,
    deleteDraftReport
  };
};

